export function normalizePath(pathname: string): string {
  return pathname
    .replace(
      /\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}(?=\/|$)/gi,
      '/:uuid'
    )
    .replace(/\/[0-9a-f]{24}(?=\/|$)/gi, '/:objectId')
    .replace(/\/\d{3,}(?=\/|$)/g, '/:id');
}
